import React, { useEffect, useState } from "react";

import Index from "../../../../container/Index";
import * as xlsx from "xlsx";
import OutlinedInput from "@mui/material/OutlinedInput";
import PagesIndex from "../../../PagesIndex";
import { Autocomplete, Tooltip, tooltipClasses } from "@mui/material";

import moment from "moment";
import dayjs from "dayjs";

import {
  addUpdateBill,
  getAllFamilyWithMohollaNameAndAreaList,
  getAllProgramList,
  getSingleDisbursedBill,
} from "../../../../redux/features/AddService";
import { billSchema } from "../../../../validation/Validation";

import { imagePath } from "../../../../config/DataService";

import PageLoading from "../../../../components/common/pageLoading/PageLoading";
import { useSelector } from "react-redux";
import { MobileDatePicker } from "@mui/x-date-pickers";
import styled from "styled-components";
import { FieldArray } from "formik";
import { toast } from "react-toastify";
import ExportSampleSheet from "../../../../components/common/excelSheet/ExportSampleSheet";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    background: "#eaac35",
    color: "#ffffff",
    fontSize: "11px",
    fontFamily: "Poppins-Regular",
    padding: "5px 9px",
    lineHeight: "19px",
    borderRadius: "10px",
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const ariaLabel = { "aria-label": "description" };

const AddBill = () => {
  const { getUserLoginDetails } = PagesIndex.useSelector(
    (state) => state.admin
  );

  const dispatch = PagesIndex.useDispatch();
  const navigate = PagesIndex.useNavigate();
  const location = PagesIndex.useLocation();
  const stateNavigate = location?.state?.editBill;

  const editBillData = location?.state?.editBill;
  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();

  //all state

  const [programList, setProgramList] = useState([]);

  const [pageLoader, setPageLoader] = useState(false);

  const [loader, setLoader] = useState(false);
  const [listForSearch, setListForSearch] = useState([]);
  const [saveErrorData, setSaveErrorData] = React.useState([]);
  const [openErrorModal, setOpenErrorModal] = React.useState(false);

  const handleCloseErrorModal = () => setOpenErrorModal(false);

  const initialValues = {
    vendorName: editBillData?.vendorName || "",
    billNumber: editBillData?.billNumber || "",
    totalAmount: editBillData?.totalAmount || "",
    programId: editBillData?.programId || "",
    billDate: moment(editBillData?.billDate).format("YYYY-MM-DD") || "",
    memberAmount:
      editBillData?.memberAmountMain?.map((row) => ({
        ...row,
        isChecked: row?.amount > 0 ? true : false,
        amount: +row?.amount > 0 ? +row?.amount : "",
      })) || [],
    BillDocuments: editBillData?.BillDocuments || [],
    isSubmit: false,

    givenAmount: editBillData?.memberAmountMain
      ? editBillData?.memberAmountMain.reduce(
          (acc, curr) => acc + (Number(curr.amount) || 0),
          0
        )
      : 0,

    remainingAmount:
      editBillData?.totalAmount -
        (editBillData?.memberAmountMain
          ? editBillData?.memberAmountMain.reduce(
              (acc, curr) => acc + (Number(curr.amount) || 0),
              0
            )
          : 0) || 0,
  };

  const handleBack = () => {
    navigate(`/${rollData}/bill-list`, {
      state: {
        rowID: location?.state?.editBill?.Id,
        prevState: location?.state?.editBill?.lastStatus,
      },
    });
  };

  const handleFormSubmit = (values, { setFieldValue }) => {
    setFieldValue("isSubmit", true);
    const data = new FormData();

    if (editBillData?.Id) {
      data.append("id", editBillData?.Id);
    }

    data.append("vendorName", values?.vendorName);
    data.append("billNumber", values?.billNumber);
    data.append("totalAmount", values?.totalAmount);
    data.append("programId", values?.programId);
    data.append("billDate", values?.billDate);

    values?.memberAmount?.forEach((amount, index) => {
      data.append(
        `memberAmount[${index}][memberId]`,
        amount?.mem_id ? amount?.mem_id : amount?.memberId
      );
      data.append(`memberAmount[${index}][amount]`, amount?.amount);
    });

    values?.BillDocuments?.length > 0 &&
      values?.BillDocuments?.forEach((ele) => {
        if (ele instanceof Blob) {
          data.append("BillDocuments", ele);
        }
      });

    values?.BillDocuments?.length > 0 &&
      values?.BillDocuments?.forEach((ele) => {
        if (ele instanceof Blob) {
        } else {
          data.append("oldDocuments", ele?.Documents);
        }
      });

    dispatch(addUpdateBill(data)).then((res) => {
      if (res?.payload?.status == 201 || 200) {
        navigate(`/${rollData}/bill-list`);
      } else {
        setTimeout(() => {
          setFieldValue("isSubmit", false);
        }, 1000);
      }
    });
  };

  const getPrograms = () => {
    dispatch(getAllProgramList()).then((res) => {
      if (res?.payload?.status === 200) {
        //   setLoader(false);
        setProgramList(res?.payload?.data);
      }
      // setLoader(false);
    });
  };

  useEffect(() => {
    getPrograms();
    if (editBillData?.memberAmountMain) {
      setListForSearch(
        editBillData?.memberAmountMain?.map((row) => ({
          ...row,
          isChecked: row?.amount > 0 ? true : false,
          amount: +row?.amount > 0 ? +row?.amount : "",
        }))
      );
    }
  }, []);

  // Search on table
  const requestSearch = (searched, setFieldValue) => {
    // Clone the list to avoid direct mutation

    if (!searched) {
      setFieldValue("memberAmount", listForSearch);
      return;
    }

    const filteredList = listForSearch.filter(
      (item) =>
        item?.memberName
          ?.toString()
          .toLowerCase()
          .includes(searched.toLowerCase()) ||
        item?.FID?.toString().toLowerCase().includes(searched.toLowerCase())
    );

    // Set the filtered list in Formik field
    setFieldValue("memberAmount", filteredList);
  };
  function modifyBulkCSVData(list, setFieldValue, values) {
    setSaveErrorData([]);
    // CSV data ko normalize karna
    const modifiedData = list?.map((item) => {
      const modifiedItem = {};

      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          const newKey = key.replace(/\s+/g, "").toLowerCase();
          modifiedItem[newKey] = item[key];
        }
      }

      return modifiedItem;
    });

    const updatedListForSearch = values?.memberAmount?.map((member, index) => {
      const matchedMember = modifiedData?.find(
        (amountData) =>
          amountData.member.toLowerCase() === member.memberName.toLowerCase()
      );

      if (matchedMember) {
        return {
          ...member,
          amount: matchedMember.amount,
          isChecked: true,
        };
      }

      return member;
    });
    modifiedData?.forEach((amountData, index) => {
      const matchedMemberInSearch = listForSearch?.find(
        (member) =>
          member.memberName.toLowerCase() === amountData.member.toLowerCase()
      );

      if (!matchedMemberInSearch) {
        // Show toaster if no match is found for the member in listForSearch

        setSaveErrorData((prevMessages) => [
          ...prevMessages,
          `${amountData.member} at index ${
            index + 1
          } not exist in this program`,
        ]);
      }
    });
    if (saveErrorData?.length > 0) {
      setOpenErrorModal(true);
    }

    const givenAmount = updatedListForSearch?.reduce(
      (sum, member) => sum + parseFloat(member.amount || 0),
      0
    );
    setFieldValue("givenAmount", givenAmount);
    setFieldValue("remainingAmount", values?.totalAmount - +givenAmount);
    // setFieldValue ko update karna
    setFieldValue("memberAmount", updatedListForSearch);
    setListForSearch(updatedListForSearch);
  }

  const handleBulkBulkChange = (e, setFieldValue, values) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const csvData = e.target.result;
        const workbook = xlsx.read(csvData, { type: "binary" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = xlsx.utils.sheet_to_json(worksheet);
        modifyBulkCSVData(json, setFieldValue, values);
      };

      reader.readAsBinaryString(file);
    }
  };

  const familyMemberExcel = listForSearch.map((item) => ({
    member: item.memberName,
    amount: item.amount, // if you want amount as a string
  }));

  // const familyMemberExcel = [
  //   {
  //     member: "",
  //     amount: "",
  //   },
  // ];

  const { rollPermissionData } = useSelector((state) => state.admin);

  if (
    rollPermissionData?.permissionArray?.includes("Disbursement_add") ||
    rollPermissionData?.permissionArray?.includes("Disbursement_edit")
  ) {
  } else {
    navigate(`/${rollData}/bill-list`);
  }

  return (
    <>
      <div>
        {pageLoader ? (
          <PageLoading />
        ) : (
          <>
            <Index.Box className="apply-sahay-main">
              <Index.Box className="head-content">
                <Index.Box
                  className={`user-right ${
                    location.pathname == "/admin/add-disbursement-application"
                      ? "admin-border-radius"
                      : ""
                  }`}
                >
                  <Index.Box
                    className={`bottom-user-right ${
                      location.pathname == "/admin/add-disbursement-application"
                        ? "admin-height-remove"
                        : ""
                    }`}
                  >
                    <Index.Box className="user-apply-content">
                      <PagesIndex.Formik
                        enableReinitialize
                        onSubmit={handleFormSubmit}
                        initialValues={initialValues}
                        validationSchema={billSchema}
                      >
                        {({
                          values,
                          handleChange,
                          handleSubmit,
                          touched,
                          setFieldValue,
                          handleBlur,
                          errors,
                          isValid,
                          isSubmitting,
                        }) => (
                          <form onSubmit={handleSubmit}>
                            <Index.Box className="main-in-row">
                              <Index.Box className="user-basic user-heading">
                                <Index.Typography
                                  component="h1"
                                  className="head-apply"
                                  mb={2}
                                >
                                  {editBillData ? "Edit Bill" : "Add Bill"}
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                            <Index.Box className="main-in-row main-card-box">
                              <Index.Box
                                className="user-basic"
                                sx={{ display: "flex" }}
                              ></Index.Box>
                              <Index.Box
                                sx={{ flexGrow: 1 }}
                                className="al-form-groups"
                              >
                                <Index.Grid container spacing={2}>
                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Program Name (પ્રોગ્રામનું નામ)
                                        <span className="required">*</span>
                                      </Index.Typography>
                                      <Index.FormControl
                                        sx={{ width: "100%" }}
                                        className="main-select"
                                      >
                                        <Index.Select
                                          className="select-drop"
                                          displayEmpty
                                          value={values?.programId}
                                          onChange={(e) => {
                                            setFieldValue(
                                              "programId",
                                              e.target.value
                                            );

                                            const memberList =
                                              programList?.find(
                                                (program) =>
                                                  program?.id == e.target.value
                                              );

                                            setFieldValue(
                                              "memberAmount",
                                              memberList?.members?.map(
                                                (row) => ({
                                                  ...row,
                                                  isChecked: false,
                                                  amount: "",
                                                })
                                              )
                                            );
                                            setListForSearch(
                                              memberList?.members?.map(
                                                (row) => ({
                                                  ...row,
                                                  isChecked: false,
                                                  amount: "",
                                                })
                                              )
                                            );
                                          }}
                                          onBlur={handleBlur}
                                          input={<OutlinedInput />}
                                          MenuProps={MenuProps}
                                          inputProps={{
                                            "aria-label": "Without label",
                                          }}
                                        >
                                          {programList?.map((ele) => (
                                            <Index.MenuItem
                                              key={ele?.Id}
                                              value={ele?.id}
                                            >
                                              {ele?.programName}
                                            </Index.MenuItem>
                                          ))}
                                        </Index.Select>
                                      </Index.FormControl>
                                    </Index.Box>
                                    {errors?.programId &&
                                      touched?.programId && (
                                        <p className="error-text">
                                          {errors?.programId}
                                        </p>
                                      )}
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Vendor Name (વિક્રેતાનું નામ)
                                        <span className="required">*</span>
                                      </Index.Typography>
                                      <Index.TextField
                                        type="text"
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="vendorName"
                                        value={values?.vendorName}
                                        onChange={(e) => {
                                          const newValue = e.target.value
                                            .replace(/^\s+/, "")
                                            .replace(/\s\s+/g, " ");
                                          setFieldValue("vendorName", newValue);
                                        }}
                                        onBlur={handleBlur}
                                      />
                                    </Index.Box>
                                    {errors?.vendorName &&
                                      touched?.vendorName && (
                                        <p className="error-text">
                                          {errors?.vendorName}
                                        </p>
                                      )}
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Bill Number (બિલ નંબર)
                                        <span className="required">*</span>
                                      </Index.Typography>
                                      <Index.TextField
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="billNumber"
                                        value={values?.billNumber}
                                        onChange={(e) => {
                                          if (e.target.value?.length <= 12) {
                                            // Only update the value if it's not more than 40 characters
                                            handleChange(e);
                                          }
                                        }}
                                        onBlur={handleBlur}
                                      />
                                    </Index.Box>
                                    {errors?.billNumber &&
                                      touched?.billNumber && (
                                        <p className="error-text">
                                          {errors?.billNumber}
                                        </p>
                                      )}
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Bill Date (બિલ તારીખ)
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border date-input-box">
                                      <Index.LocalizationProvider
                                        dateAdapter={Index.AdapterDayjs}
                                        sx={{ position: "absolute" }}
                                      >
                                        <Index.DemoContainer
                                          components={["DatePicker"]}
                                        >
                                          <MobileDatePicker
                                            name="billDate"
                                            onChange={(value) => {
                                              setFieldValue(
                                                "billDate",
                                                moment(value.$d).format(
                                                  "YYYY-MM-DD"
                                                )
                                              );
                                            }}
                                            value={dayjs(values?.billDate)}
                                            format="YYYY-MM-DD"
                                            sx={{
                                              overflowY: "hidden",
                                              position: "relative",
                                              bottom: "8px",
                                              width: "100%",
                                            }}
                                            slotProps={{
                                              textField: {
                                                size: "small",
                                                error: false,
                                              },
                                            }}
                                          />
                                        </Index.DemoContainer>
                                      </Index.LocalizationProvider>
                                    </Index.Box>
                                    {errors?.billDate && touched.billDate && (
                                      <p className="error-text">
                                        {errors?.billDate}
                                      </p>
                                    )}
                                  </Index.Grid>

                                  <>
                                    <Index.Grid
                                      item
                                      xs={12}
                                      sm={4}
                                      md={4}
                                      lg={4}
                                    >
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Total Amount (કુલ રકમ)
                                          <span className="required">*</span>
                                        </Index.Typography>
                                        <Index.TextField
                                          type="number"
                                          inputProps={ariaLabel}
                                          className="basic-input input-width"
                                          name="totalAmount"
                                          value={values?.totalAmount}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                        />
                                      </Index.Box>
                                      {errors?.totalAmount &&
                                        touched.totalAmount && (
                                          <p className="error-text">
                                            {errors?.totalAmount}
                                          </p>
                                        )}
                                    </Index.Grid>
                                    <Index.Grid
                                      item
                                      xs={12}
                                      sm={4}
                                      md={4}
                                      lg={4}
                                    ></Index.Grid>

                                    <Index.Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={5}
                                      lg={5}
                                    >
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Add Multiple Document (બહુવિધ દસ્તાવેજ
                                          ઉમેરો)
                                        </Index.Typography>
                                        <Index.Box className="select-position">
                                          <input
                                            type="file"
                                            name="BillDocuments"
                                            multiple
                                            className="ori-input"
                                            onChange={(event) => {
                                              const files = event.target.files;
                                              setFieldValue("BillDocuments", [
                                                ...values?.BillDocuments,
                                                ...files,
                                              ]);
                                            }}
                                          />

                                          <Index.Box className="select-file">
                                            Upload Your Document
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={8}>
                                      <Index.Box className="select-view-document-name">
                                        {values?.BillDocuments?.map(
                                          (file, index) => (
                                            <Index.Box
                                              className="document-name"
                                              key={index}
                                            >
                                              <Index.Typography
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                  // Implement the logic to view the document here
                                                  // You can use a modal or a new browser tab/window to show the document
                                                  window.open(
                                                    file instanceof Blob
                                                      ? URL.createObjectURL(
                                                          file
                                                        )
                                                      : `${imagePath}${file?.Documents}`
                                                  );
                                                }}
                                              >
                                                {file?.name
                                                  ? file?.name
                                                  : file?.Filename}
                                              </Index.Typography>
                                              <Index.IconButton
                                                onClick={() => {
                                                  const updatedDocuments =
                                                    values?.BillDocuments?.filter(
                                                      (_, i) => i !== index
                                                    );
                                                  setFieldValue(
                                                    "BillDocuments",
                                                    updatedDocuments
                                                  );
                                                }}
                                              >
                                                <Index.ClearIcon className="muiico-cancel" />
                                              </Index.IconButton>
                                            </Index.Box>
                                          )
                                        )}
                                      </Index.Box>
                                    </Index.Grid>
                                    <Index.Box className="divider"></Index.Box>
                                    <Index.Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={12}
                                      lg={12}
                                    >
                                      <Index.Box
                                        className="custom-bills-csv-box"
                                        sx={{ justifyContent: "start" }}
                                      >
                                        <Index.Grid
                                          item
                                          xs={12}
                                          sm={6}
                                          md={6}
                                          lg={3}
                                        >
                                          <Index.Box className="lable-input-grp">
                                            <Index.Typography
                                              component="p"
                                              className="in-label"
                                            >
                                              Search (શોધો)
                                            </Index.Typography>

                                            <Index.TextField
                                              inputProps={ariaLabel}
                                              className="basic-input input-width"
                                              onChange={(e) => {
                                                requestSearch(
                                                  e.target.value,
                                                  setFieldValue
                                                );
                                              }}
                                            />
                                          </Index.Box>
                                        </Index.Grid>
                                        {/* <Index.Grid
                                          item
                                          xs={12}
                                          sm={6}
                                          md={6}
                                          lg={3}
                                          mb={2}
                                          mt={2}
                                        > */}
                                        <Index.Box className="common-button blue-button res-blue-button ">
                                          <LightTooltip>
                                            <Index.Button
                                              className="csv-button"
                                              disabled={
                                                !values?.programId ||
                                                !values?.totalAmount
                                              }
                                            >
                                              <label
                                                htmlFor="actual-btn-bulk"
                                                style={{ cursor: "pointer" }}
                                              >
                                                Import CSV
                                              </label>
                                              <input
                                                type="file"
                                                id="actual-btn-bulk"
                                                // onChange={
                                                //   tabValue === 0
                                                //     ? handleCSVChange
                                                //     : handleCSVChangeCurrent
                                                // }
                                                value=""
                                                onChange={(e) =>
                                                  handleBulkBulkChange(
                                                    e,
                                                    setFieldValue,
                                                    values
                                                  )
                                                }
                                                hidden
                                                accept=".csv"
                                              />
                                            </Index.Button>
                                          </LightTooltip>
                                        </Index.Box>
                                        <Index.Box
                                          gridColumn={{
                                            xs: "span 12",
                                            sm: "span 6",
                                            md: "span 4",
                                            lg: "span 4",
                                          }}
                                          className="grid-column"
                                        >
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.Box
                                              Box
                                              className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                                            >
                                              <ExportSampleSheet
                                                apiData={familyMemberExcel}
                                                fileName={"Bill CSV Sample"}
                                              />
                                            </Index.Box>
                                          </Index.Box>
                                        </Index.Box>
                                        {/* </Index.Grid> */}
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={12}
                                      lg={12}
                                      mb={12}
                                    >
                                      <Index.Box className="">
                                        <Index.TableContainer
                                          sx={{ maxHeight: 480 }}
                                          component={Index.Paper}
                                          className="table-container sahay-application-container scroll-table"
                                        >
                                          <Index.Table
                                            stickyHeader
                                            aria-label="sticky table"
                                            className="table-design-main barge-table sahay-appli-table add-bill-table-custom"
                                          >
                                            <Index.TableHead className="sahay-appli-head">
                                              <Index.TableRow className="sahay-appli-tr">
                                                <Index.TableCell
                                                  className="sahay-appli-tr"
                                                  align="left"
                                                ></Index.TableCell>
                                                <Index.TableCell
                                                  className="sahay-appli-tr"
                                                  align="left"
                                                >
                                                  Family Id (કૌટુંબિક આઈડી)
                                                </Index.TableCell>
                                                <Index.TableCell
                                                  className="sahay-appli-tr"
                                                  align="left"
                                                >
                                                  Member (સભ્ય)
                                                </Index.TableCell>

                                                <Index.TableCell
                                                  className="sahay-appli-tr"
                                                  align="left"
                                                >
                                                  Amount (રકમ)
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            </Index.TableHead>

                                            <Index.TableBody>
                                              <FieldArray name="memberAmount">
                                                <>
                                                  {values?.memberAmount
                                                    ?.length ? (
                                                    values?.memberAmount?.map(
                                                      (row, index) => (
                                                        <Index.TableRow
                                                          key={index}
                                                          className={`sahay-appli-tr`}
                                                        >
                                                          <Index.TableCell
                                                            component="td"
                                                            variant="td"
                                                            scope="row"
                                                            className="sahay-appli-td"
                                                            align="left"
                                                          >
                                                            <Index.Checkbox
                                                              component="td"
                                                              variant="td"
                                                              scope="row"
                                                              className="check-box-role"
                                                              align="left"
                                                              checked={
                                                                row?.isChecked
                                                              }
                                                              onChange={(e) =>
                                                                setFieldValue(
                                                                  `memberAmount[${index}].isChecked`,
                                                                  !row?.isChecked
                                                                )
                                                              }
                                                            />
                                                          </Index.TableCell>

                                                          <Index.TableCell
                                                            align="left"
                                                            className="sahay-appli-td"
                                                          >
                                                            {row?.FID
                                                              ? row?.FID
                                                              : row?.mem_family_id}
                                                          </Index.TableCell>

                                                          <Index.TableCell
                                                            align="left"
                                                            className="sahay-appli-td"
                                                          >
                                                            {row?.memberName}
                                                          </Index.TableCell>

                                                          <Index.TableCell
                                                            align="left"
                                                            className="sahay-appli-td"
                                                          >
                                                            <Index.Grid
                                                              item
                                                              xs={12}
                                                              sm={12}
                                                              md={12}
                                                              lg={12}
                                                              key={index}
                                                            >
                                                              <Index.Box className="input-design-div with-border">
                                                                <Index.TextField
                                                                  inputProps={{
                                                                    ...ariaLabel,
                                                                    disabled:
                                                                      row?.isChecked ==
                                                                      false,
                                                                  }}
                                                                  onBlur={
                                                                    handleBlur
                                                                  }
                                                                  className="basic-input input-width"
                                                                  name={`memberAmount[${index}].amount`}
                                                                  value={
                                                                    values
                                                                      ?.memberAmount[
                                                                      index
                                                                    ].amount
                                                                  }
                                                                  type="number"
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    const newValue =
                                                                      Number(
                                                                        e.target
                                                                          .value
                                                                      ) || "";

                                                                    setFieldValue(
                                                                      `memberAmount[${index}].amount`,
                                                                      newValue
                                                                    );

                                                                    // Given amount ka sum recalculate karein
                                                                    const newSum =
                                                                      values?.memberAmount?.reduce(
                                                                        (
                                                                          acc,
                                                                          curr,
                                                                          i
                                                                        ) =>
                                                                          acc +
                                                                          (i ===
                                                                          index
                                                                            ? newValue
                                                                            : Number(
                                                                                curr.amount
                                                                              ) ||
                                                                              0),
                                                                        0
                                                                      );

                                                                    setFieldValue(
                                                                      "givenAmount",
                                                                      newSum
                                                                    );
                                                                    setFieldValue(
                                                                      "remainingAmount",
                                                                      values?.totalAmount -
                                                                        newSum
                                                                    );
                                                                  }}
                                                                />
                                                              </Index.Box>

                                                              {errors
                                                                ?.memberAmount
                                                                ?.length !==
                                                              0 ? (
                                                                errors
                                                                  ?.memberAmount?.[
                                                                  index
                                                                ]?.amount &&
                                                                touched
                                                                  ?.memberAmount?.[
                                                                  index
                                                                ]?.amount && (
                                                                  <p className="error-text">
                                                                    {
                                                                      errors
                                                                        ?.memberAmount[
                                                                        index
                                                                      ]?.amount
                                                                    }
                                                                  </p>
                                                                )
                                                              ) : (
                                                                <></>
                                                              )}
                                                            </Index.Grid>
                                                          </Index.TableCell>
                                                        </Index.TableRow>
                                                      )
                                                    )
                                                  ) : (
                                                    <PagesIndex.NoRecordFound
                                                      colSpan={12}
                                                    />
                                                  )}
                                                </>
                                              </FieldArray>
                                            </Index.TableBody>
                                          </Index.Table>
                                        </Index.TableContainer>
                                        {typeof errors?.memberAmount ==
                                          "string" && (
                                          <p className="error-text">
                                            {touched?.memberAmount &&
                                              errors?.memberAmount}
                                          </p>
                                        )}
                                      </Index.Box>
                                      <Index.Box className="main-in-row">
                                        <Index.Box
                                          className="user-basic"
                                          sx={{ display: "flex" }}
                                        ></Index.Box>
                                        <Index.Box
                                          sx={{ flexGrow: 1 }}
                                          className="al-form-groups"
                                        >
                                          <Index.Grid container spacing={2}>
                                            <>
                                              <Index.Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={6}
                                                lg={3}
                                                mb={2}
                                              >
                                                <Index.Box className="lable-input-grp">
                                                  <Index.Typography
                                                    component="p"
                                                    className="in-label"
                                                  >
                                                    Total Amount (કુલ રકમ)
                                                  </Index.Typography>
                                                  <Index.TextField
                                                    type="number"
                                                    inputProps={ariaLabel}
                                                    className="basic-input input-width"
                                                    name="totalAmount"
                                                    value={values?.totalAmount}
                                                    disabled
                                                  />
                                                </Index.Box>
                                              </Index.Grid>
                                              <Index.Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={6}
                                                lg={3}
                                                mb={2}
                                              >
                                                <Index.Box className="lable-input-grp">
                                                  <Index.Typography
                                                    component="p"
                                                    className="in-label"
                                                  >
                                                    Distributed Amount (વિતરિત
                                                    રકમ)
                                                  </Index.Typography>
                                                  <Index.TextField
                                                    type="number"
                                                    inputProps={ariaLabel}
                                                    className="basic-input input-width"
                                                    name="totalAmount"
                                                    value={values?.givenAmount}
                                                    disabled
                                                  />
                                                </Index.Box>
                                              </Index.Grid>{" "}
                                              <Index.Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={6}
                                                lg={3}
                                                mb={2}
                                              >
                                                <Index.Box className="lable-input-grp">
                                                  <Index.Typography
                                                    component="p"
                                                    className="in-label"
                                                  >
                                                    Remaining Amount (બાકીની
                                                    રકમ)
                                                  </Index.Typography>
                                                  <Index.TextField
                                                    type="number"
                                                    inputProps={ariaLabel}
                                                    className="basic-input input-width"
                                                    name="totalAmount"
                                                    value={
                                                      values?.remainingAmount
                                                    }
                                                    disabled
                                                  />
                                                </Index.Box>
                                              </Index.Grid>
                                            </>
                                          </Index.Grid>
                                        </Index.Box>
                                      </Index.Box>
                                    </Index.Grid>
                                  </>
                                </Index.Grid>
                              </Index.Box>
                            </Index.Box>

                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups fam-in-grp"
                            >
                              <Index.Grid item xs={6}>
                                <Index.Box className="common-button blue-button flex-end save-btn back-btn">
                                  <Index.Button
                                    variant="contained"
                                    onClick={() => handleBack()}
                                  >
                                    Back
                                  </Index.Button>
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid container spacing={2}>
                                <Index.Grid item xs={6}>
                                  <Index.Box className="lable-input-grp ">
                                    <Index.Box className="select-position">
                                      <Index.Box
                                        className={
                                          values.isSubmit === false
                                            ? "apply-now"
                                            : "disable-now"
                                        }
                                      >
                                        <button
                                          type="submit"
                                          disabled={values.isSubmit}
                                        >
                                          {editBillData == undefined
                                            ? "Submit"
                                            : "Update"}
                                        </button>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            </Index.Box>
                          </form>
                        )}
                      </PagesIndex.Formik>

                      <Index.Box className="title-header-flex "></Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </>
        )}
      </div>
      <Index.Modal
        open={openErrorModal}
        onClose={handleCloseErrorModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal-delete modal"
      >
        <Index.Box sx={style} className="delete-modal-inner-main modal-inner">
          <Index.Box className="remark-textarea-details">
            <Index.Box className="set-text-area ">
              <Index.Typography
                variant="label"
                component="label"
                className="input-label"
              >
                <ul>
                  {saveErrorData &&
                    saveErrorData.map((error, index) => (
                      <li key={index} style={{ marginBottom: "10px" }}>
                        {error}.
                      </li>
                    ))}
                </ul>
              </Index.Typography>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Modal>
    </>
  );
};

export default AddBill;
